var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 40,
    viewBox: "0 0 102 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9121 32.6087H78.6947V4.78271H73.9121V32.6087Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6521 28.6559C57.5862 28.6559 55.2278 26.6006 54.7954 23.4781H70.9112L71.3043 23.0828V22.1738C71.3043 15.9287 67.0592 11.739 60.6521 11.739C54.2451 11.739 50 15.9287 50 22.1738C50 28.4188 54.2451 32.6085 60.6521 32.6085C65.3304 32.6085 69.4157 29.8248 70.813 25.652H65.879C64.8979 27.454 62.8453 28.6559 60.6521 28.6559ZM60.6521 15.6916C58.0186 15.6916 56.0139 17.075 55.1099 19.5255H66.1944C65.2903 17.075 63.2857 15.6916 60.6521 15.6916Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3041 32.6085H21.5215V12.1738H26.3041V32.6085Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.6087H18.6956V27.8261H4.78261V4.78271H0L0 32.6087Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3047 39.9998H91.0873L101.739 12.1738H96.9568L91.522 27.3912L86.0873 12.1738H81.3047L89.1307 32.6085L86.3047 39.9998Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9569 32.6085H41.7395L49.5656 12.1738H44.783L39.3482 27.3912L33.9134 12.1738H29.1309L36.9569 32.6085Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9135 2.60869C22.7128 2.60869 21.7395 3.58198 21.7395 4.7826C21.7395 5.98321 22.7128 6.9565 23.9135 6.9565C25.1141 6.9565 26.0874 5.98321 26.0874 4.7826C26.0874 3.58198 25.1141 2.60869 23.9135 2.60869ZM19.1309 4.7826C19.1309 2.14124 21.2721 0 23.9135 0C26.5548 0 28.6961 2.14124 28.6961 4.7826C28.6961 7.42395 26.5548 9.56519 23.9135 9.56519C21.2721 9.56519 19.1309 7.42395 19.1309 4.7826Z",
    fill: "url(#paint0_linear_545_13490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_13490",
    x1: 20.4352,
    y1: 8.26085,
    x2: 28.8268,
    y2: 5.01822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC10D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2400FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.31420af06af27b3bd1363762ffcf053f.svg";
export { ForwardRef as ReactComponent };